import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import AutoComplete, { createFilterOptions } from '@mui/material/Autocomplete';
import {Box, ThemeProvider } from '@mui/material';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const DrugPayIp = (props) => {
  const {ip_id} = useParams();

  const [patientData, setPatientData] = useState([]);
  const [consData, setConsData] = useState([]);
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([{ id: '', product: '', batch: '', expiry: '', totqty: '', uamount: '',  }]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [disPer, setDisPer] = useState(0);
  const [disAmount, setDisAmount] = useState(0);
  const [iptotData,setIptotData] = useState([]);
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
  const nextQtyInputRef = useRef(null);

  const [pharmData,setpharmData]=useState({
        "sale_id":'',
        "sale_type":'',
        "pat":'',
        "patient":'',
        "cons":'',
        "product":'',
        "qty":'',
        "netamount":'',
        "total":'',
        "disc":'',
        "details":'',
        "paid":'',
        "balance":'',
        "mode":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
     });

  useEffect(() => {
    fetchPatData();
    fetchPharmData();
    fetchConsData();
    fetchIptotData();
  }, []);

  function fetchPharmData(page = 1, pageSize = 5000) {
      axios.get(`${baseUrl}indent-pharm-search/?dept=Pharmacy&page=${page}&page_size=${pageSize}`)
      .then((pharmResponse) => {
        setItems(pharmResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


  function fetchConsData() {
    axios.get(`${baseUrl}cons-search/`)
      .then((consResponse) => {
        setConsData(consResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchPatData() {
     axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then((patResponse) => {
        setPatientData([patResponse.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchIptotData() {
      axios.get(baseUrl + "view-ip-tot/" + ip_id)
      .then((ipResponse) => {
        setIptotData([ipResponse.data]);
      })
    .catch (error => {
      console.log(error);
    });
  }

  const consultantOptions = consData.map((cons) => ({
      value: cons.id,
      label: cons.consultant,
  }));
  const handleConsChange = (event, value) => {
      if (value) {
        setpharmData(prevState => ({ ...prevState, cons: value.value }));
      } else {
        setpharmData(prevState => ({ ...prevState, cons: '' }));
      }
    };

  const handleKeyDown = (e, index) => {
      const newRows = [...rows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (e.target.name === 'product' || e.target.name === 'qty') {
                e.preventDefault();
                if (index === rows.length - 1) {
                  newRows.push({ id: '', product: '', batch: '', expiry: '', totqty: '', uamount: '' });
                }
              }
          break;
        // Handle arrow up key
        case 18:
          e.preventDefault();
            newRows.splice(index, 1);
          break;
        case 38:
          e.preventDefault();
          if (newRows[index].selectedItem === 0) {
            newRows[index].selectedItem = items.length - 1;
          } else {
            newRows[index].selectedItem--;
          }
          setRows(newRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newRows[index].selectedItem === items.length - 1) {
            newRows[index].selectedItem = 0;
          } else {
            newRows[index].selectedItem++;
          }
          setRows(newRows);
          break;
        default:
          break;
      }
      setRows(newRows);
    };

 const handleSelect = (event, value, index, id) => {
    const selectedItem = value;

    if (!selectedItem) {
      console.log('Selected item not found');
      return;
    }


    const today = new Date(formattedDate);
    const expiry = new Date(selectedItem.product.expiry); // already YYYY-MM-DD

    // Calculate difference in days
    const diffTime = expiry.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
      Swal.fire(`${diffDays} day(s) since expired`);
      return;
    }

    const newRows = [...rows];
    const existingRowIndex = newRows.findIndex(row => row.id === selectedItem.id);

    if (existingRowIndex !== -1) {
      newRows[existingRowIndex].qty += 1;
      newRows[existingRowIndex].remainQty = newRows[existingRowIndex].totqty - newRows[existingRowIndex].qty;
      newRows[existingRowIndex].netamount = newRows[existingRowIndex].qty * newRows[existingRowIndex].uamount;
      if (newRows[existingRowIndex].remainQty < 0) {
        Swal.fire("Stock not available");
        newRows[existingRowIndex].remainQty = 0;
        newRows[existingRowIndex].qty = newRows[existingRowIndex].totqty;
        newRows[existingRowIndex].netamount = newRows[existingRowIndex].totqty * newRows[existingRowIndex].uamount;
      }
    } else {
      newRows[index] = {
        id: selectedItem.id,
        product: selectedItem.product.product,
        batch: selectedItem.product.batch,
        expiry: selectedItem.product.expiry,
        totqty: selectedItem.qty,
        uamount: selectedItem.product.uamount,
        qty: '',
        remainqty: selectedItem.qty - 1,
        netamount: selectedItem.product.uamount,
      };
    }

    setRows(newRows);

    if (diffDays < 15) {
      Swal.fire(`${diffDays} day(s) to expire. Total qty = ${selectedItem.qty}`);
    }


if (inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
 if (nextQtyInputRef.current) {
      nextQtyInputRef.current.focus();
    }
};

const handleAmountChange = (e, index) => {
  const newRows = [...rows];
  newRows[index].qty = parseFloat(e.target.value) || 0;
  newRows[index].uamount = parseFloat(newRows[index].uamount) || 1;
  const netamount = (newRows[index].qty * newRows[index].uamount).toFixed(2);
  newRows[index].netamount = parseFloat(netamount);
  const remainQty = newRows[index].totqty - newRows[index].qty;
  if (remainQty < 0) {
    Swal.fire("Stock not available");
    newRows[index].remainQty = 0;
    newRows[index].qty = newRows[index].totqty;
    newRows[index].netamount = parseFloat((newRows[index].totqty * newRows[index].uamount).toFixed(2));
  } else {
    newRows[index].remainQty = remainQty;
  }
  setRows(newRows);
};


  const handleAddRow = () => {
    const newRows = [...rows];
    newRows.push({ id: '', product: '', batch: '', expiry: '', totqty: '', uamount: ''});
    setRows(newRows);
  };

 const inputRefs = useRef([]);
    useEffect(() => {
    if (inputRefs.current.length > 0) {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
    }
  }, [rows.length]);

 const handleDeleteRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
    inputRefs.current.splice(index, 1);
  };

  const handleDisPerChange = (e) => {
   const newDisPer = parseFloat(e.target.value) || 0;
   setDisPer(newDisPer);
  };

  useEffect(() => {
    let subTotal = 0;
    let disAmount = 0;
    let newTotal = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subTotal += row.netamount;
      disAmount = subTotal * ( parseFloat(disPer) /100 );
      newTotal = subTotal - disAmount;
    }
    setSubTotal(subTotal);
    setDisPer(disPer);
    setDisAmount(disAmount);
    setTotal(newTotal);
  }, [rows, disPer]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setpharmData(prevState => ({ ...prevState, [name]: value }));
  };

  const formSubmit = (e) => {
      e.preventDefault();
        const patid = document.getElementById("patid").value;
        const dbType = document.getElementById('dbType').value;
        const details = document.getElementById("details").value;
         if (!pharmData.cons) {
            Swal.fire('Error', 'Please select a consultant.', 'error');
            return;
          }
        const ids= rows.map(row => row.id);
        const qtys = rows.map(row => row.qty);
        const eqtys= rows.map(row => row.totqty);
        const totqtyMap = {};
        eqtys.forEach((totqty, index) => {
          const id = ids[index];
          totqtyMap[id] = totqty - qtys[index];
        });
        const drugData = ids.map((id, index) => ({ id, qty: qtys[index] }));
          axios.post(`${baseUrl}get_sale_pharm/`)
          .then(response => {
          const sale_id = response.data.value;
          const _formData = new FormData();
          _formData.append('sale_id', sale_id);
          _formData.append('sale_type', 'IPBill');
          _formData.append('pat', patid);
          _formData.append('patient', ip_id);
          _formData.append('cons', pharmData.cons.value);
          _formData.append('product', rows.map(row => row.id).join(','));
          _formData.append('qty', rows.map(row => row.qty).join(','));
          _formData.append('netamount', rows.map(row => row.netamount).join(','));
          _formData.append('total', total.toFixed(2));
          _formData.append('disc', disAmount.toFixed(2));
          if(dbType=='creditpay'){
          _formData.append('paid', 0);
          _formData.append('balance', total.toFixed(2));
          }else{
          _formData.append('paid', total.toFixed(2));
          _formData.append('balance', 0);
          }
          _formData.append('mode', dbType);
          _formData.append('details', details);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

       const updatePromises = drugData.map(drug => {
         const { id, qty } = drug;
         const pharmData = {
            id: id,
            qty: qty,
            ip_add: ipAddress,
          };
          return axios.post(`${baseUrl}update-indent-quantity/`, pharmData)
          .then(response => {
            console.log(response.data);
          })
          .catch(error => {
            console.log(error);
          });
      });
      Promise.all(updatePromises)
        .then(() => {
          axios.post(`${baseUrl}pharm-sale-other/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                if(dbType=='advance'){
                    const tid = iptotData[0][0].id;
                    const tot_invoiced = parseFloat(iptotData[0][0].tot_invoiced) + parseFloat(total);
                    const tot_paid = parseFloat(iptotData[0][0].tot_paid) + parseFloat(total);
                    const remain_balance = parseFloat(iptotData[0][0].remain_balance) + parseFloat(total);
                    const tot_used = parseFloat(iptotData[0][0].tot_used) + parseFloat(total);
                    const ipData = {
                            tot_invoiced: tot_invoiced.toFixed(2),
                            tot_paid: tot_paid.toFixed(2),
                            remain_balance: remain_balance.toFixed(2),
                            tot_used: tot_used.toFixed(2),
                            addedby: userName,
                            ip_add: ipAddress,
                            location: userLocation,
                        }
                    axios.put(`${baseUrl}update-ip-tot/${tid}/`, ipData)
                    .then(response => {
                         console.log(response.data);
                    });
                }
                Swal.fire({
                  title: 'Pharmacy Bill Generated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/pharm-invoice-other/' + sale_id;
                }, 3000);
              }
            });
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to generate unique value. Please try again later.',
            'error'
          );
        });
  };

const navigate = useNavigate();

  const handleButtonClick = () => {
    // Redirect to /drug-pay-other/0 and force a page refresh
     const newWindow = window.open('/drug-pay-other/0', '_blank');
    if (newWindow) {
      newWindow.focus();
      newWindow.onload = () => newWindow.location.reload();
    }
  };
  const customFilterOptions = (options, state) => {
    const inputValue = state.inputValue.toLowerCase();

    if (inputValue.length < 3) {
      return [];
    }

    const filteredOptions = options.filter(option => {
      const label = (option.label || option.product?.product || '').toLowerCase();
      return label.startsWith(inputValue);
    });

    return filteredOptions;
  };

  return (
  <section className="container mt-4">
  <form>
   <div className="row table-responsive">
    <div className='col-md-12 col-12 mb-2'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Regd. On</th>
          <th>Consultant</th>
        </tr>
      </thead>

      <tbody>
        {patientData.length > 0 ? (
           patientData.map((patientData, index) => (
          <tr key={index}>
            <td style={{width:'10%'}}><input className="form-control" type="text" name="patid" id="patid" value={patientData.pat.id} /></td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.add_date}</td>
            <td>
                {consData.length > 0 && (
                 <AutoComplete
                  id="combo-box-demo"
                  options={consultantOptions}
                  getOptionlabel={(option) => option.label}
                  onChange={(event, value) => setpharmData(prevState => ({ ...prevState, cons: value }))}
                  renderInput={(params) => (
                    <TextField {...params} onChange={handleConsChange} name="cons" required />
                  )}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                />
                )}
            </td>
          </tr>
        ))
        ) : (
          <tr>
            <td style={{ width: '10%' }}>
              <input type="number" className="form-control" name="patid" id="patid"  />
            </td>
            <td style={{ width: '20%' }}>
              <input type="text" className="form-control" name="patient" id="patient"  />
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td>
                {consData.length > 0 && (
                 <AutoComplete
                  id="combo-box-demo"
                  options={consultantOptions}
                  getOptionlabel={(option) => option.label}
                  onChange={(event, value) => setpharmData(prevState => ({ ...prevState, cons: value }))}
                  renderInput={(params) => (
                    <TextField {...params} onChange={handleConsChange} name="cons" required />
                  )}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                />
                )}
            </td>
          </tr>
          )}
      </tbody>
    </table>
    </div>
   </div>

    <div className='table-responsive'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 60}}>ID</th>
          <th style={{width: 200}}>Drug Name</th>
          <th style={{width: 80}} >Qty</th>
          <th style={{width: 120}}>Batch</th>
          <th style={{width: 120}}>Expiry</th>
          <th style={{width: 80}} >Qty in Stock</th>
          <th style={{width: 110}} >MRP 1s</th>
          <th style={{width: 120}}>Net Amount</th>
          <th style={{width: 110}} >Remain Qty</th>
                 <th style={{width: 80}} >Action</th>

        </tr>
      </thead>

      <tbody>
      {rows.map((row, index) => (
        <tr key={index}>
        <td>
        <input
            type="text"
            name="id"
            value={row.id}
            onChange={(e) => handleChange(e, index)}
            style={{width: 60}}
            tabIndex={-1}
            readOnly
          />
          </td>
        <td>
        <AutoComplete
          id={`product-${index}`}
          sx={{ width: 200 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
            options={items}
                  value={items.find(item => item.product.product === row.product) || null}
                  getOptionLabel={(option) => option.product.product || ''}
                  onChange={(event, value, id) => handleSelect(event, value, index, id)}
                  renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                      <input
                        {...params.inputProps}
                        className="form-control"
                        type="text"
                        autoFocus
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        style={{ background: "#F7EEFF" }}
                      />
                    </div>
                  )}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} sx={{ width: 750, height: 50, borderRadius: 1 }}>
                      {option.product ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch} TQty: ${option.qty}` : ''}
                    </Box>
                  )}
                  filterOptions={customFilterOptions}
                  ref={(el) => inputRefs.current[index] = el}
                />
           </td>
           <td>
          <input
  type="number"
  min={0}
  step="1"   // ✅ restrict to whole numbers
  style={{ width: 90 }}
  className="ms-3 me-1"
  value={row.qty}
  name="qty"
  onChange={(e) => {
    let value = e.target.value;

    // ✅ prevent decimals manually
    if (value.includes(".")) return;

    if (value >= 0) {
      handleChange(e);
      handleAmountChange(e, index);
    }
  }}
  onKeyDown={(e) => {
    // ✅ block dot key
    if (e.key === "." || e.key === "e") {
      e.preventDefault();
    }
    handleKeyDown(e, index);
  }}
  tabIndex={0}
  ref={nextQtyInputRef}
  required
/>
            </td>
            <td>
            <input
              type="text"

              style={{width: 110}}
              name="batch"
              value={row.batch}
              onChange={(e) => handleChange(e, index)}
              tabIndex={-1}
            />
            </td>
            <td>
            <input
              type="text"
              className="ms-2 me-1"
              style={{width: 90}}
              name="expiry"
              value={row.expiry}
              onChange={(e) => handleChange(e, index)}
              tabIndex={-1}
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="totqty"
              value={row.totqty}
              onChange={(e) => handleChange(e, index)}
              tabIndex={-1}
              readOnly
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="uamount"
              value={row.uamount}
              onChange={(e) => {
                handleChange(e);
                handleAmountChange(e, index);
              }}
              tabIndex={-1}
              readOnly
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 140}}
              name="netamount"
              value={row.netamount}
              tabIndex={-1}
              readOnly
            />
            </td>
            <td>
            <input
              type="number"
              className="ms-2 me-1"
              name="remainQty"
              style={{width: 80}}
              value={row.remainQty}
              readOnly
              tabIndex={-1}
            />
            </td>
            <td>
             <button className="btn btn-danger" type="button" onClick={() => handleDeleteRow(index)}>Delete</button>
             </td>
        </tr>
      ))}
    </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More</button>
  <div className="row ms-5 mt-5">

  <div className="col-md-6">
  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
    <div className="form-group">
      <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" value={subtotal} readOnly />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">%</div>
        <input
          type="number"
          value={disPer}
          name="disPer"
          id="disPer"
          onChange={handleDisPerChange}
        />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input
          type="number"
          onChange={handleChange}
          name="disAmount"
          id="disAmount"
          value={disAmount}
        />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} name="tot" value={total} readOnly />
      </div>
    </div>
  </div>
  </div>
  <div className="col-md-6">
    <div className="form-group">
      <label>Choose Payment Type</label>
        <select name="dbType" id="dbType">
           <option value="advance">From Advance</option>
           <option value="cash">Cash</option>
           <option value="card">Card</option>
           <option value="creditpay">Credit Payment</option>
           <option value="UPI">UPI</option>
        </select>
    </div>
    <div className="form-group">
      <label>Details:</label>
      <textarea
        className="no-comma form-control"
        tabIndex="0"
        name="details"
        id="details"
        rows={2}
        cols={2}
      ></textarea>
    </div>
  </div>
</div>
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button"  onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
</div>
    </div>
    </form>
  </section>
  );
};

export default DrugPayIp;
